import { BASE_API_URL } from "../../Components/config";

const ROOMS = `${BASE_API_URL}/api/v1/session-rooms`;

const headers = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
});

const call = async (url, options = {}) => {
  const res = await fetch(url, { ...options, headers: headers() });
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const err = new Error((data && typeof data.detail === "string" && data.detail) || "Something went wrong. Try again.");
    err.status = res.status;
    throw err;
  }
  return data;
};

/** A session's life, and what it ran — the parts of a space that are not
 *  the session list itself (that is useSessions'). */
export const spaceApi = {
  /** The teacher opened the room: the session is live. */
  startSession: (sessionGuid) => call(`${ROOMS}/${sessionGuid}/start`, { method: "POST" }),
  /** The teacher ended the class. */
  endSession: (sessionGuid) => call(`${ROOMS}/${sessionGuid}/end`, { method: "POST" }),
  /** Everything a session ran in its room, newest first. */
  activities: (sessionGuid) => call(`${ROOMS}/${sessionGuid}/activities`),
  /** One of those, as this person may see it. */
  activity: (sessionGuid, activityGuid) => call(`${ROOMS}/${sessionGuid}/activities/${activityGuid}`),
};
